import { Component, ViewChild, Directive, ElementRef, ViewContainerRef, Input, HostListener, NgModule } from '@angular/core';
import { OverlayConfig, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { take } from 'rxjs/operators';
import { ComponentPortal } from '@angular/cdk/portal';
import { genPositionPairs } from 'mis-crystal-design-system/utils';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/overlay';

const _c0 = ["container"];
const _c1 = function (a0, a1, a2, a3) { return { "arrow-left": a0, "arrow-right": a1, "arrow-top": a2, "arrow-bottom": a3 }; };
function ToolTipComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2)(2, "div", 3)(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "span", 5);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.toolTipText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(2, _c1, ctx_r0.toolTipPosition === "left", ctx_r0.toolTipPosition === "right", ctx_r0.toolTipPosition === "top", ctx_r0.toolTipPosition === "bottom"));
} }
class ToolTipComponent {
    constructor() {
        this.toolTipText = "";
        this.toolTipPosition = "bottom";
    }
    ngOnInit() { }
    ngAfterViewInit() {
        var _a;
        if (!((_a = this.container) === null || _a === void 0 ? void 0 : _a.nativeElement))
            return;
        if (this.toolTipPosition === "top" || this.toolTipPosition === "bottom") {
            const eleWidth = this.container.nativeElement.getBoundingClientRect();
            this.container.nativeElement.style.left = eleWidth.width / -2 + "px";
            return;
        }
        if (this.toolTipPosition === "left") {
            const eleWidth = this.container.nativeElement.getBoundingClientRect();
            this.container.nativeElement.style.left = -eleWidth.width + "px";
        }
    }
}
ToolTipComponent.ɵfac = function ToolTipComponent_Factory(t) { return new (t || ToolTipComponent)(); };
ToolTipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToolTipComponent, selectors: [["mis-tooltip"]], viewQuery: function ToolTipComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, decls: 1, vars: 1, consts: [["id", "tooltip-container", 4, "ngIf"], ["id", "tooltip-container"], ["container", ""], ["id", "tooltip"], ["id", "tooltip-text"], ["id", "arrow", 3, "ngClass"]], template: function ToolTipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ToolTipComponent_div_0_Template, 6, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.toolTipText.length > 0);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["#tooltip-container[_ngcontent-%COMP%]{position:absolute;z-index:1}#tooltip[_ngcontent-%COMP%]{position:relative;display:block;padding:8px 12px;border-radius:8px;color:#fff;background:#181f33;font-family:Lato,sans-serif;font-style:normal;font-weight:400;font-size:14px;line-height:20px;text-align:center;letter-spacing:.2px}#tooltip-text[_ngcontent-%COMP%]{width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}#arrow[_ngcontent-%COMP%]{position:absolute;height:12px;width:12px;background:#181f33;z-index:1}.arrow-top[_ngcontent-%COMP%]{bottom:-6px}.arrow-bottom[_ngcontent-%COMP%], .arrow-top[_ngcontent-%COMP%]{left:50%;transform:translateX(-50%) rotate(-45deg);-webkit-transform:translateX(-50%) rotate(-45deg)}.arrow-bottom[_ngcontent-%COMP%]{top:-6px}.arrow-left[_ngcontent-%COMP%]{right:-6px}.arrow-left[_ngcontent-%COMP%], .arrow-right[_ngcontent-%COMP%]{top:50%;transform:translateY(-50%) rotate(-45deg);-webkit-transform:translateY(-50%) rotate(-45deg)}.arrow-right[_ngcontent-%COMP%]{left:-6px}"] });
ToolTipComponent.ctorParameters = () => [];
ToolTipComponent.propDecorators = {
    container: [{ type: ViewChild, args: ["container",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolTipComponent, [{
        type: Component,
        args: [{ selector: "mis-tooltip", template: "<div id=\"tooltip-container\" *ngIf=\"toolTipText.length > 0\" #container>\n  <div id=\"tooltip\">\n    <div id=\"tooltip-text\">{{ toolTipText }}</div>\n    <span\n      id=\"arrow\"\n      [ngClass]=\"{\n        'arrow-left': toolTipPosition === 'left',\n        'arrow-right': toolTipPosition === 'right',\n        'arrow-top': toolTipPosition === 'top',\n        'arrow-bottom': toolTipPosition === 'bottom'\n      }\"\n    ></span>\n  </div>\n</div>\n", styles: ["#tooltip-container{position:absolute;z-index:1}#tooltip{position:relative;display:block;padding:8px 12px;border-radius:8px;color:#fff;background:#181f33;font-family:Lato,sans-serif;font-style:normal;font-weight:400;font-size:14px;line-height:20px;text-align:center;letter-spacing:.2px}#tooltip-text{width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}#arrow{position:absolute;height:12px;width:12px;background:#181f33;z-index:1}.arrow-top{bottom:-6px}.arrow-bottom,.arrow-top{left:50%;transform:translateX(-50%) rotate(-45deg);-webkit-transform:translateX(-50%) rotate(-45deg)}.arrow-bottom{top:-6px}.arrow-left{right:-6px}.arrow-left,.arrow-right{top:50%;transform:translateY(-50%) rotate(-45deg);-webkit-transform:translateY(-50%) rotate(-45deg)}.arrow-right{left:-6px}"] }]
    }], function () { return []; }, { container: [{
            type: ViewChild,
            args: ["container"]
        }] }); })();

class ToolTipDirective {
    constructor(element, overlay, viewContainerRef) {
        this.element = element;
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.isToolTipDisplayed = false;
        this.toolTipText = "";
        this.toolTipPosition = "bottom";
        this.showOnHover = true;
    }
    set showToolTip(value) {
        this.isToolTipDisplayed = value;
        if (value)
            this.displayToolTip();
        else
            this.hideToolTip();
    }
    set text(value) {
        this.toolTipText = value;
    }
    set position(value) {
        this.toolTipPosition = value;
    }
    onMouseEnter() {
        if (this.showOnHover)
            this.displayToolTip();
    }
    onMouseLeave() {
        if (this.showOnHover)
            this.hideToolTip();
    }
    ngOnInit() { }
    ngAfterViewInit() {
        if (this.isToolTipDisplayed)
            this.displayToolTip();
        else
            this.hideToolTip();
    }
    displayToolTip() {
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.element)
            .withPositions(genPositionPairs({
            positionX: "center",
            positionY: this.toolTipPosition === "top" ? "top" : "center",
            offsetX: this.positionTooltip("OFFSET_X"),
            offsetY: this.positionTooltip("OFFSET_Y")
        }, false))
            .withPush(true);
        const config = new OverlayConfig({
            hasBackdrop: false,
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.reposition()
        });
        this.overlayRef = this.overlay.create(config);
        const tempRef = new ComponentPortal(ToolTipComponent, this.viewContainerRef);
        const tooltipRef = this.overlayRef.attach(tempRef);
        tooltipRef.instance.toolTipText = this.toolTipText;
        tooltipRef.instance.toolTipPosition = this.toolTipPosition;
        this.overlayRef
            .backdropClick()
            .pipe(take(1))
            .subscribe(() => {
            this.hideToolTip();
        });
    }
    positionTooltip(type) {
        if (type === "OFFSET_X") {
            return this.toolTipPosition === "right"
                ? this.element.nativeElement.offsetWidth / 2 + 8
                : this.toolTipPosition === "left"
                    ? (this.element.nativeElement.offsetWidth / 2 + 8) * -1
                    : this.toolTipPosition === "top" || this.toolTipPosition === "bottom"
                        ? 0
                        : 8;
        }
        if (type !== "OFFSET_Y")
            return;
        return this.toolTipPosition === "right" || this.toolTipPosition === "left"
            ? -18
            : this.toolTipPosition === "top"
                ? -44
                : this.toolTipPosition === "bottom"
                    ? this.element.nativeElement.offsetHeight / 2 + 8
                    : 8;
    }
    hideToolTip() {
        var _a, _b;
        (_a = this.overlayRef) === null || _a === void 0 ? void 0 : _a.detach();
        (_b = this.overlayRef) === null || _b === void 0 ? void 0 : _b.dispose();
    }
}
ToolTipDirective.ɵfac = function ToolTipDirective_Factory(t) { return new (t || ToolTipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
ToolTipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ToolTipDirective, selectors: [["", "misToolTip", ""]], hostBindings: function ToolTipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function ToolTipDirective_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function ToolTipDirective_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); });
    } }, inputs: { showOnHover: "showOnHover", showToolTip: "showToolTip", text: "text", position: "position" } });
ToolTipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Overlay },
    { type: ViewContainerRef }
];
ToolTipDirective.propDecorators = {
    showOnHover: [{ type: Input }],
    showToolTip: [{ type: Input }],
    text: [{ type: Input }],
    position: [{ type: Input }],
    onMouseEnter: [{ type: HostListener, args: ["mouseenter",] }],
    onMouseLeave: [{ type: HostListener, args: ["mouseleave",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolTipDirective, [{
        type: Directive,
        args: [{
                selector: "[misToolTip]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc2.Overlay }, { type: ɵngcc0.ViewContainerRef }]; }, { showOnHover: [{
            type: Input
        }], showToolTip: [{
            type: Input
        }], text: [{
            type: Input
        }], position: [{
            type: Input
        }], onMouseEnter: [{
            type: HostListener,
            args: ["mouseenter"]
        }], onMouseLeave: [{
            type: HostListener,
            args: ["mouseleave"]
        }] }); })();

class ToolTipModule {
    static forRoot() {
        return { ngModule: ToolTipModule, providers: [] };
    }
}
ToolTipModule.ɵfac = function ToolTipModule_Factory(t) { return new (t || ToolTipModule)(); };
ToolTipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToolTipModule });
ToolTipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, OverlayModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToolTipModule, [{
        type: NgModule,
        args: [{
                declarations: [ToolTipDirective, ToolTipComponent],
                imports: [CommonModule, OverlayModule],
                exports: [ToolTipDirective, ToolTipComponent],
                entryComponents: [ToolTipComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToolTipModule, { declarations: function () { return [ToolTipDirective, ToolTipComponent]; }, imports: function () { return [CommonModule, OverlayModule]; }, exports: function () { return [ToolTipDirective, ToolTipComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ToolTipComponent, ToolTipDirective, ToolTipModule };

